<div class="modal-header">
    <div class="modal-title">Add Users</div>

    <button id="invite-user-btn" type="button" class="close" aria-label="Close" (click)="closeClick()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <form #inviteUserForm="ngForm" novalidate="novalidate" autocomplete="off">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <div class="label">Email of the users to add</div>
                    <input type="text" class="input input__large input__blue" placeholder="e.g. supermail@mail.com"
                        [(ngModel)]="objInviteUser.EMAIL" #EMAIL="ngModel" maxlength="50" name="EMAIL"
                        [pattern]="commonService.emailPattern" required>
                    <ng-container *ngIf="(!EMAIL.valid && !EMAIL.untouched) && (EMAIL.errors?.required || EMAIL.errors?.pattern)">
                        <div *ngIf="!EMAIL.errors?.required && EMAIL.errors?.pattern" class="error-text">
                            The email you entered isn’t correct. Please check email.
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <div class="label">First Name</div>
                    <input type="text" class="input input__large input__blue" placeholder="First Name"
                        [(ngModel)]="objInviteUser.FIRST_NAME" #FIRST_NAME="ngModel" maxlength="20" name="FIRST_NAME" required>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <div class="label">Last Name</div>
                    <input type="text" class="input input__large input__blue" placeholder="Last Name"
                        [(ngModel)]="objInviteUser.LAST_NAME" #LAST_NAME="ngModel" maxlength="20" name="LAST_NAME" required>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <div class="label">Organization Role</div>
                    <app-custom-select #ROLE_ID="ngModel"
                        [(ngModel)]="objInviteUser.ROLE_ID" [values]="roles"
                        placeholder="Select Type" name="ROLE_ID" id="ROLE_ID" required>
                    </app-custom-select>
                </div>
            </div>
        </div>

    </form>
</div>

<div class="modal-footer">
    <button id="invite-user-cancel-btn" type="button" class="button secondary__button large__button"
        (click)="closeClick()">Cancel</button>
    <button id="invite-add0users-btn" type="button" class="button primary__button large__button" [disabled]="!inviteUserForm.valid"
        (click)="submitClick()">Add User</button>
</div>
